export class BenefitType {
    
    id: number = 0;
    code!: string;
    description!: string;
    
}